<template>
  <div class="wrapper">
    <c-button2 class="button" size="small" label="Коды в табеле" :disabled="disabled" @click="toggle" />

    <div v-if="isOpened" class="container">
      <shadow-scroll-container class="list">
        <div v-for="item in codes" :key="item.id" class="item">
          <div
            class="item__code"
            :style="{
              background: item.color,
            }"
          >
            {{ item.code }}
          </div>
          <div class="item__name">{{ item.name }}</div>
        </div>
      </shadow-scroll-container>
    </div>
  </div>
</template>

<script>
import CButton2 from "@/components/controls2/Button";
import ShadowScrollContainer from "@/components/shadow-scroll-container";

export default {
  components: { CButton2, ShadowScrollContainer },
  props: ["disabled"],
  data() {
    return {
      codes: [],
      isOpened: false,
    };
  },
  watch: {
    disabled(v) {
      if (!v) {
        this.isOpened = false;
      }
    },
  },
  created() {
    this.getCodes().then((items) => {
      this.codes = items;
    });
  },
  mounted() {
    this._cb = (e) => {
      if (!this.isOpened) return;
      const container = this.$el.querySelector(".container");
      if (container && container.contains(e.target)) return;
      this.isOpened = false;
    };

    document.addEventListener("click", this._cb);
  },
  beforeDestroy() {
    document.removeEventListener("click", this._cb);
    this._cb = null;
  },
  methods: {
    toggle(e) {
      if (this.disabled) {
        this.isOpened = false;
        return;
      }
      e.stopPropagation();
      this.isOpened = !this.isOpened;
    },
    getCodes() {
      return this.$store.dispatch("timesheets/getVacationTypes").then((items) =>
        items
          .filter((i) => i.timesheet_code)
          .map((i) => ({
            code: i.timesheet_code,
            color: i.color,
            name: i.name,
          })),
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;

  .container {
    position: absolute;
    z-index: 5;
    left: 0;
    top: 100%;
    margin-top: 10px;
    box-shadow: 0px 4px 16px rgba(0, 15, 38, 0.25);
    border-radius: 6px;
    background-color: white;
    padding: 20px;
    width: auto;
    max-width: 440px;

    .list {
      font-size: 15px;
      line-height: 1.2;
      max-height: 440px;
    }

    .item {
      display: flex;

      &:not(:last-child) {
        margin-bottom: 5px;
      }

      &__code {
        width: 33px;
        height: 24px;
        margin-right: 10px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &__name {
        padding-top: 4px;
      }
    }
  }
}
</style>
